import { useToggle } from 'usehooks-ts';
import { useTranslation } from 'react-i18next';

// Import types
import type { VodSubtype } from 'types/api/products/product';

const usePacketsButton = (subtype: VodSubtype) => {
	const { t } = useTranslation();

	const [isModalVisible, toggleModalVisibility] = useToggle(false);

	const buttonText = t(`vod_buttons_check_availability_${subtype}`);

	return {
		buttonText,
		isModalVisible,
		toggleModalVisibility
	};
};

export default usePacketsButton;
